import React from "react";
import TextButton from "../../../templates/component/buttons/textButton";

const DonationInformationAddButton = () =>{

    return(
        <>
            <TextButton />

        </>
    )
}

export default DonationInformationAddButton;